import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Table  } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";

const ListTenantReport = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    loadDataTenant,
    getDocumentsTenant,
    documentsTenant,
    countTenant
  } = rootStore.reportStore;

  useEffect(() => {
    getDocumentsTenant();
  }, [getDocumentsTenant]);

  if (!loadDataTenant) return <LoadingComponent content="Cargando" />;
  return (
    <div className="TableScroll">
    <Table striped basic unstackable compact singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Nombre Cliente</Table.HeaderCell>          
          <Table.HeaderCell>NIT</Table.HeaderCell>
          <Table.HeaderCell>No. Documentos Exitosos</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {documentsTenant?.length > 0 ? (
          documentsTenant.map((t) => ( 
            <Table.Row key={`${t.tenantId}-${t.tenantName}`}>
              <Table.Cell singleLine>{t.tenantName}</Table.Cell>
              <Table.Cell singleLine>{t.companyId}</Table.Cell>
              <Table.Cell>{t.numberOfDocuments}</Table.Cell>              
            </Table.Row>
          ))
        ) : (
          <Table.Row key="tenantReportNull">
            <Table.Cell>No existen Clientes</Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
      <Table.Footer>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell>Total</Table.HeaderCell>
          <Table.HeaderCell>{countTenant}</Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
    </div>
  );
};

export default observer(ListTenantReport);
